export enum QuestionType {
  MULTI_SELECT = 'MULTI_SELECT',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TRUE_OR_FALSE = 'TRUE_OR_FALSE',
  SHORT_ANSWER = 'SHORT_ANSWER',
  DESCRIPTIVE = 'DESCRIPTIVE'

}
